// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SbzwEQvle06ZlSVgWU9w {
  display: inline-flex;
  border: none;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  padding: 0;
}
.SbzwEQvle06ZlSVgWU9w.gIWgNlNf9Iy2aoZ35f5t {
  border-radius: var(--button-24-border-radius);
  min-height: var(--button-24-height);
}
.SbzwEQvle06ZlSVgWU9w.gIWgNlNf9Iy2aoZ35f5t .UKnOuM4nRvoF7ovP5IJr {
  border-radius: var(--button-24-border-radius);
  gap: var(--button-24-gap);
  padding: var(--button-24-padding-vertical) var(--button-24-padding-horizontal);
}
.SbzwEQvle06ZlSVgWU9w.gIWgNlNf9Iy2aoZ35f5t.N6CxTZzjUCVAEFVOinv9 .UKnOuM4nRvoF7ovP5IJr {
  padding: var(--button-24-padding-square);
  aspect-ratio: 1/1;
  min-width: var(--button-24-height);
}
.SbzwEQvle06ZlSVgWU9w.uoQ1r2y19GGD2U4UFiss {
  border-radius: var(--button-28-border-radius);
  min-height: var(--button-28-height);
}
.SbzwEQvle06ZlSVgWU9w.uoQ1r2y19GGD2U4UFiss .UKnOuM4nRvoF7ovP5IJr {
  border-radius: var(--button-28-border-radius);
  gap: var(--button-28-gap);
  padding: var(--button-28-padding-vertical) var(--button-28-padding-horizontal);
}
.SbzwEQvle06ZlSVgWU9w.uoQ1r2y19GGD2U4UFiss.N6CxTZzjUCVAEFVOinv9 .UKnOuM4nRvoF7ovP5IJr {
  padding: var(--button-28-padding-square);
  aspect-ratio: 1/1;
  min-width: var(--button-28-height);
}
.SbzwEQvle06ZlSVgWU9w.cG3uVuAzOLvqU0hYhQ7A {
  border-radius: var(--button-32-border-radius);
  min-height: var(--button-32-height);
}
.SbzwEQvle06ZlSVgWU9w.cG3uVuAzOLvqU0hYhQ7A .UKnOuM4nRvoF7ovP5IJr {
  border-radius: var(--button-32-border-radius);
  gap: var(--button-32-gap);
  padding: var(--button-32-padding-vertical) var(--button-32-padding-horizontal);
}
.SbzwEQvle06ZlSVgWU9w.cG3uVuAzOLvqU0hYhQ7A.N6CxTZzjUCVAEFVOinv9 .UKnOuM4nRvoF7ovP5IJr {
  padding: var(--button-32-padding-square);
  aspect-ratio: 1/1;
  min-width: var(--button-32-height);
}
.SbzwEQvle06ZlSVgWU9w.Y8zViTvTRtISvkumYX3b {
  border-radius: var(--button-36-border-radius);
  min-height: var(--button-36-height);
}
.SbzwEQvle06ZlSVgWU9w.Y8zViTvTRtISvkumYX3b .UKnOuM4nRvoF7ovP5IJr {
  border-radius: var(--button-36-border-radius);
  gap: var(--button-36-gap);
  padding: var(--button-36-padding-vertical) var(--button-36-padding-horizontal);
}
.SbzwEQvle06ZlSVgWU9w.Y8zViTvTRtISvkumYX3b.N6CxTZzjUCVAEFVOinv9 .UKnOuM4nRvoF7ovP5IJr {
  padding: var(--button-36-padding-square);
  aspect-ratio: 1/1;
  min-width: var(--button-36-height);
}
.SbzwEQvle06ZlSVgWU9w.iYJ2UuVjusqWfXIW4nAD {
  border-radius: var(--button-44-border-radius);
  min-height: var(--button-44-height);
}
.SbzwEQvle06ZlSVgWU9w.iYJ2UuVjusqWfXIW4nAD .UKnOuM4nRvoF7ovP5IJr {
  border-radius: var(--button-44-border-radius);
  gap: var(--button-44-gap);
  padding: var(--button-44-padding-vertical) var(--button-44-padding-horizontal);
}
.SbzwEQvle06ZlSVgWU9w.iYJ2UuVjusqWfXIW4nAD.N6CxTZzjUCVAEFVOinv9 .UKnOuM4nRvoF7ovP5IJr {
  padding: var(--button-44-padding-square);
  aspect-ratio: 1/1;
  min-width: var(--button-44-height);
}
.SbzwEQvle06ZlSVgWU9w.pjrORQRnyGSU1jo7Ad2V {
  border-radius: var(--button-52-border-radius);
  min-height: var(--button-52-height);
}
.SbzwEQvle06ZlSVgWU9w.pjrORQRnyGSU1jo7Ad2V .UKnOuM4nRvoF7ovP5IJr {
  border-radius: var(--button-52-border-radius);
  gap: var(--button-52-gap);
  padding: var(--button-52-padding-vertical) var(--button-52-padding-horizontal);
}
.SbzwEQvle06ZlSVgWU9w.pjrORQRnyGSU1jo7Ad2V.N6CxTZzjUCVAEFVOinv9 .UKnOuM4nRvoF7ovP5IJr {
  padding: var(--button-52-padding-square);
  aspect-ratio: 1/1;
  min-width: var(--button-52-height);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV {
  background-color: var(--button-tonal-default-bg);
  color: var(--button-tonal-default-text);
  border: var(--button-tonal-default-border, none);
  opacity: var(--button-tonal-default-opacity, 1);
  box-shadow: var(--button-tonal-default-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-tonal-default-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV {
  font-family: var(--button-tonal-default-font-family, inherit);
  font-size: var(--button-tonal-default-font-size, inherit);
  font-weight: var(--button-tonal-default-weight, inherit);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:hover:not(:disabled) {
  background-color: var(--button-tonal-hover-bg);
  color: var(--button-tonal-hover-text);
  border: var(--button-tonal-hover-border, none);
  opacity: var(--button-tonal-hover-opacity, 1);
  box-shadow: var(--button-tonal-hover-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:hover:not(:disabled) .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-tonal-hover-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:focus-visible {
  background-color: var(--button-tonal-focused-bg);
  color: var(--button-tonal-focused-text);
  border: var(--button-tonal-focused-border, none);
  opacity: var(--button-tonal-focused-opacity, 1);
  box-shadow: var(--button-tonal-focused-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:focus-visible .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-tonal-focused-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:active:not(:disabled), .SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV[data-active=true] {
  background-color: var(--button-tonal-active-bg);
  color: var(--button-tonal-active-text);
  border: var(--button-tonal-active-border, none);
  opacity: var(--button-tonal-active-opacity, 1);
  box-shadow: var(--button-tonal-active-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:active:not(:disabled) .UKnOuM4nRvoF7ovP5IJr, .SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV[data-active=true] .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-tonal-active-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:disabled {
  background-color: var(--button-tonal-disabled-bg);
  color: var(--button-tonal-disabled-text);
  border: var(--button-tonal-disabled-border none);
  opacity: var(--button-tonal-disabled-opacity, 1);
  box-shadow: var(--button-tonal-disabled-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV:disabled .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-tonal-disabled-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV[data-error=true] {
  background-color: var(--M3-sys-light-error);
  color: var(--M3-sys-light-on-error);
  border: 1.5px solid var(--M3-sys-light-error);
}
.SbzwEQvle06ZlSVgWU9w.N1gFS2vuCCAsO9ovSOWV {
  transition: background-color 0.2s ease-in-out;
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr {
  background-color: var(--button-outlined-default-bg);
  color: var(--button-outlined-default-text);
  border: var(--button-outlined-default-border, none);
  opacity: var(--button-outlined-default-opacity, 1);
  box-shadow: var(--button-outlined-default-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-default-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr {
  font-family: var(--button-outlined-default-font-family, inherit);
  font-size: var(--button-outlined-default-font-size, inherit);
  font-weight: var(--button-outlined-default-weight, inherit);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:hover:not(:disabled) {
  background-color: var(--button-outlined-hover-bg);
  color: var(--button-outlined-hover-text);
  border: var(--button-outlined-hover-border, none);
  opacity: var(--button-outlined-hover-opacity, 1);
  box-shadow: var(--button-outlined-hover-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:hover:not(:disabled) .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-hover-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:focus-visible {
  background-color: var(--button-outlined-focused-bg);
  color: var(--button-outlined-focused-text);
  border: var(--button-outlined-focused-border, none);
  opacity: var(--button-outlined-focused-opacity, 1);
  box-shadow: var(--button-outlined-focused-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:focus-visible .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-focused-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:active:not(:disabled), .SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr[data-active=true] {
  background-color: var(--button-outlined-active-bg);
  color: var(--button-outlined-active-text);
  border: var(--button-outlined-active-border, none);
  opacity: var(--button-outlined-active-opacity, 1);
  box-shadow: var(--button-outlined-active-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:active:not(:disabled) .UKnOuM4nRvoF7ovP5IJr, .SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr[data-active=true] .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-active-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:disabled {
  background-color: var(--button-outlined-disabled-bg);
  color: var(--button-outlined-disabled-text);
  border: var(--button-outlined-disabled-border none);
  opacity: var(--button-outlined-disabled-opacity, 1);
  box-shadow: var(--button-outlined-disabled-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr:disabled .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-disabled-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr[data-error=true] {
  background-color: var(--M3-sys-light-error);
  color: var(--M3-sys-light-on-error);
  border: 1.5px solid var(--M3-sys-light-error);
}
.SbzwEQvle06ZlSVgWU9w.KRX3MAA5GXAS0Nub_dOr {
  transition: background-color 0.2s ease-in-out;
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO {
  background-color: var(--button-filled-default-bg);
  color: var(--button-filled-default-text);
  border: var(--button-filled-default-border, none);
  opacity: var(--button-filled-default-opacity, 1);
  box-shadow: var(--button-filled-default-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-filled-default-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO {
  font-family: var(--button-filled-default-font-family, inherit);
  font-size: var(--button-filled-default-font-size, inherit);
  font-weight: var(--button-filled-default-weight, inherit);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:hover:not(:disabled) {
  background-color: var(--button-filled-hover-bg);
  color: var(--button-filled-hover-text);
  border: var(--button-filled-hover-border, none);
  opacity: var(--button-filled-hover-opacity, 1);
  box-shadow: var(--button-filled-hover-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:hover:not(:disabled) .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-filled-hover-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:focus-visible {
  background-color: var(--button-filled-focused-bg);
  color: var(--button-filled-focused-text);
  border: var(--button-filled-focused-border, none);
  opacity: var(--button-filled-focused-opacity, 1);
  box-shadow: var(--button-filled-focused-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:focus-visible .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-filled-focused-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:active:not(:disabled), .SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO[data-active=true] {
  background-color: var(--button-filled-active-bg);
  color: var(--button-filled-active-text);
  border: var(--button-filled-active-border, none);
  opacity: var(--button-filled-active-opacity, 1);
  box-shadow: var(--button-filled-active-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:active:not(:disabled) .UKnOuM4nRvoF7ovP5IJr, .SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO[data-active=true] .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-filled-active-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:disabled {
  background-color: var(--button-filled-disabled-bg);
  color: var(--button-filled-disabled-text);
  border: var(--button-filled-disabled-border none);
  opacity: var(--button-filled-disabled-opacity, 1);
  box-shadow: var(--button-filled-disabled-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO:disabled .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-filled-disabled-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO[data-error=true] {
  background-color: var(--M3-sys-light-error);
  color: var(--M3-sys-light-on-error);
  border: 1.5px solid var(--M3-sys-light-error);
}
.SbzwEQvle06ZlSVgWU9w.jtCKpfYc2dKTeT2qRwJO {
  transition: background-color 0.2s ease-in-out;
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq {
  background-color: var(--button-text-default-bg);
  color: var(--button-text-default-text);
  border: var(--button-text-default-border, none);
  opacity: var(--button-text-default-opacity, 1);
  box-shadow: var(--button-text-default-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-text-default-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq {
  font-family: var(--button-text-default-font-family, inherit);
  font-size: var(--button-text-default-font-size, inherit);
  font-weight: var(--button-text-default-weight, inherit);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:hover:not(:disabled) {
  background-color: var(--button-text-hover-bg);
  color: var(--button-text-hover-text);
  border: var(--button-text-hover-border, none);
  opacity: var(--button-text-hover-opacity, 1);
  box-shadow: var(--button-text-hover-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:hover:not(:disabled) .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-text-hover-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:focus-visible {
  background-color: var(--button-text-focused-bg);
  color: var(--button-text-focused-text);
  border: var(--button-text-focused-border, none);
  opacity: var(--button-text-focused-opacity, 1);
  box-shadow: var(--button-text-focused-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:focus-visible .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-text-focused-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:active:not(:disabled), .SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq[data-active=true] {
  background-color: var(--button-text-active-bg);
  color: var(--button-text-active-text);
  border: var(--button-text-active-border, none);
  opacity: var(--button-text-active-opacity, 1);
  box-shadow: var(--button-text-active-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:active:not(:disabled) .UKnOuM4nRvoF7ovP5IJr, .SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq[data-active=true] .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-text-active-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:disabled {
  background-color: var(--button-text-disabled-bg);
  color: var(--button-text-disabled-text);
  border: var(--button-text-disabled-border none);
  opacity: var(--button-text-disabled-opacity, 1);
  box-shadow: var(--button-text-disabled-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq:disabled .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-text-disabled-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq[data-error=true] {
  background-color: var(--M3-sys-light-error);
  color: var(--M3-sys-light-on-error);
  border: 1.5px solid var(--M3-sys-light-error);
}
.SbzwEQvle06ZlSVgWU9w.VC1NiBT59FkoTd4_XRJq {
  transition: background-color 0.2s ease-in-out;
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB {
  background-color: var(--button-outlined-danger-default-bg);
  color: var(--button-outlined-danger-default-text);
  border: var(--button-outlined-danger-default-border, none);
  opacity: var(--button-outlined-danger-default-opacity, 1);
  box-shadow: var(--button-outlined-danger-default-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-danger-default-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB {
  font-family: var(--button-outlined-danger-default-font-family, inherit);
  font-size: var(--button-outlined-danger-default-font-size, inherit);
  font-weight: var(--button-outlined-danger-default-weight, inherit);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:hover:not(:disabled) {
  background-color: var(--button-outlined-danger-hover-bg);
  color: var(--button-outlined-danger-hover-text);
  border: var(--button-outlined-danger-hover-border, none);
  opacity: var(--button-outlined-danger-hover-opacity, 1);
  box-shadow: var(--button-outlined-danger-hover-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:hover:not(:disabled) .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-danger-hover-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:focus-visible {
  background-color: var(--button-outlined-danger-focused-bg);
  color: var(--button-outlined-danger-focused-text);
  border: var(--button-outlined-danger-focused-border, none);
  opacity: var(--button-outlined-danger-focused-opacity, 1);
  box-shadow: var(--button-outlined-danger-focused-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:focus-visible .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-danger-focused-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:active:not(:disabled), .SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB[data-active=true] {
  background-color: var(--button-outlined-danger-active-bg);
  color: var(--button-outlined-danger-active-text);
  border: var(--button-outlined-danger-active-border, none);
  opacity: var(--button-outlined-danger-active-opacity, 1);
  box-shadow: var(--button-outlined-danger-active-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:active:not(:disabled) .UKnOuM4nRvoF7ovP5IJr, .SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB[data-active=true] .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-danger-active-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:disabled {
  background-color: var(--button-outlined-danger-disabled-bg);
  color: var(--button-outlined-danger-disabled-text);
  border: var(--button-outlined-danger-disabled-border none);
  opacity: var(--button-outlined-danger-disabled-opacity, 1);
  box-shadow: var(--button-outlined-danger-disabled-shadow, none);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB:disabled .UKnOuM4nRvoF7ovP5IJr {
  background-color: var(--button-outlined-danger-disabled-state-bg, transparent);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB[data-error=true] {
  background-color: var(--M3-sys-light-error);
  color: var(--M3-sys-light-on-error);
  border: 1.5px solid var(--M3-sys-light-error);
}
.SbzwEQvle06ZlSVgWU9w.QDvjywShxC4jIa50gFRB {
  transition: background-color 0.2s ease-in-out;
}
.SbzwEQvle06ZlSVgWU9w .UKnOuM4nRvoF7ovP5IJr {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}
.SbzwEQvle06ZlSVgWU9w .UKnOuM4nRvoF7ovP5IJr span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.SbzwEQvle06ZlSVgWU9w .UKnOuM4nRvoF7ovP5IJr svg,
.SbzwEQvle06ZlSVgWU9w .UKnOuM4nRvoF7ovP5IJr i {
  min-height: 1em;
  min-width: 1em;
  flex-shrink: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/UiKit/Buttons/Button/Button.module.scss"],"names":[],"mappings":"AA2GA;EACE,oBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AA1GF;AA6GE;EAhHA,6CAAA;EACA,mCAAA;AAMF;AAJE;EACE,6CAAA;EACA,yBAAA;EACA,8EAAA;AAMJ;AAFI;EACE,wCAAA;EACA,iBAAA;EACA,kCAAA;AAIN;AAmGE;EApHA,6CAAA;EACA,mCAAA;AAoBF;AAlBE;EACE,6CAAA;EACA,yBAAA;EACA,8EAAA;AAoBJ;AAhBI;EACE,wCAAA;EACA,iBAAA;EACA,kCAAA;AAkBN;AAyFE;EAxHA,6CAAA;EACA,mCAAA;AAkCF;AAhCE;EACE,6CAAA;EACA,yBAAA;EACA,8EAAA;AAkCJ;AA9BI;EACE,wCAAA;EACA,iBAAA;EACA,kCAAA;AAgCN;AA+EE;EA5HA,6CAAA;EACA,mCAAA;AAgDF;AA9CE;EACE,6CAAA;EACA,yBAAA;EACA,8EAAA;AAgDJ;AA5CI;EACE,wCAAA;EACA,iBAAA;EACA,kCAAA;AA8CN;AAqEE;EAhIA,6CAAA;EACA,mCAAA;AA8DF;AA5DE;EACE,6CAAA;EACA,yBAAA;EACA,8EAAA;AA8DJ;AA1DI;EACE,wCAAA;EACA,iBAAA;EACA,kCAAA;AA4DN;AA2DE;EApIA,6CAAA;EACA,mCAAA;AA4EF;AA1EE;EACE,6CAAA;EACA,yBAAA;EACA,8EAAA;AA4EJ;AAxEI;EACE,wCAAA;EACA,iBAAA;EACA,kCAAA;AA0EN;AAkDE;EAlHA,gDAAA;EACA,uCAAA;EACA,gDAAA;EACA,+CAAA;EACA,oDAAA;AAmEF;AAlEE;EACE,mEAAA;AAoEJ;AAwCE;EAzGA,6DAAA;EACA,yDAAA;EACA,wDAAA;AAoEF;AAjEE;EACE,8CAAA;EACA,qCAAA;EACA,8CAAA;EACA,6CAAA;EACA,kDAAA;AAmEJ;AAjEI;EACE,iEAAA;AAmEN;AA/DE;EACE,gDAAA;EACA,uCAAA;EACA,gDAAA;EACA,+CAAA;EACA,oDAAA;AAiEJ;AA/DI;EACE,mEAAA;AAiEN;AA7DE;EAEE,+CAAA;EACA,sCAAA;EACA,+CAAA;EACA,8CAAA;EACA,mDAAA;AA8DJ;AA5DI;EACE,kEAAA;AA8DN;AA1DE;EACE,iDAAA;EACA,wCAAA;EACA,gDAAA;EACA,gDAAA;EACA,qDAAA;AA4DJ;AA1DI;EACE,oEAAA;AA4DN;AAxDE;EACE,YAAA;EACA,oBAAA;AA0DJ;AAvDE;EACE,2CAAA;EACA,mCAAA;EACA,6CAAA;AAyDJ;AAdE;EAvCA,6CAAA;AAwDF;AAbE;EAtHA,mDAAA;EACA,0CAAA;EACA,mDAAA;EACA,kDAAA;EACA,uDAAA;AAsIF;AArIE;EACE,sEAAA;AAuIJ;AAvBE;EA7GA,gEAAA;EACA,4DAAA;EACA,2DAAA;AAuIF;AApIE;EACE,iDAAA;EACA,wCAAA;EACA,iDAAA;EACA,gDAAA;EACA,qDAAA;AAsIJ;AApII;EACE,oEAAA;AAsIN;AAlIE;EACE,mDAAA;EACA,0CAAA;EACA,mDAAA;EACA,kDAAA;EACA,uDAAA;AAoIJ;AAlII;EACE,sEAAA;AAoIN;AAhIE;EAEE,kDAAA;EACA,yCAAA;EACA,kDAAA;EACA,iDAAA;EACA,sDAAA;AAiIJ;AA/HI;EACE,qEAAA;AAiIN;AA7HE;EACE,oDAAA;EACA,2CAAA;EACA,mDAAA;EACA,mDAAA;EACA,wDAAA;AA+HJ;AA7HI;EACE,uEAAA;AA+HN;AA3HE;EACE,YAAA;EACA,oBAAA;AA6HJ;AA1HE;EACE,2CAAA;EACA,mCAAA;EACA,6CAAA;AA4HJ;AA7EE;EA3CA,6CAAA;AA2HF;AA5EE;EA1HA,iDAAA;EACA,wCAAA;EACA,iDAAA;EACA,gDAAA;EACA,qDAAA;AAyMF;AAxME;EACE,oEAAA;AA0MJ;AAtFE;EAjHA,8DAAA;EACA,0DAAA;EACA,yDAAA;AA0MF;AAvME;EACE,+CAAA;EACA,sCAAA;EACA,+CAAA;EACA,8CAAA;EACA,mDAAA;AAyMJ;AAvMI;EACE,kEAAA;AAyMN;AArME;EACE,iDAAA;EACA,wCAAA;EACA,iDAAA;EACA,gDAAA;EACA,qDAAA;AAuMJ;AArMI;EACE,oEAAA;AAuMN;AAnME;EAEE,gDAAA;EACA,uCAAA;EACA,gDAAA;EACA,+CAAA;EACA,oDAAA;AAoMJ;AAlMI;EACE,mEAAA;AAoMN;AAhME;EACE,kDAAA;EACA,yCAAA;EACA,iDAAA;EACA,iDAAA;EACA,sDAAA;AAkMJ;AAhMI;EACE,qEAAA;AAkMN;AA9LE;EACE,YAAA;EACA,oBAAA;AAgMJ;AA7LE;EACE,2CAAA;EACA,mCAAA;EACA,6CAAA;AA+LJ;AA5IE;EA/CA,6CAAA;AA8LF;AA3IE;EA9HA,+CAAA;EACA,sCAAA;EACA,+CAAA;EACA,8CAAA;EACA,mDAAA;AA4QF;AA3QE;EACE,kEAAA;AA6QJ;AArJE;EArHA,4DAAA;EACA,wDAAA;EACA,uDAAA;AA6QF;AA1QE;EACE,6CAAA;EACA,oCAAA;EACA,6CAAA;EACA,4CAAA;EACA,iDAAA;AA4QJ;AA1QI;EACE,gEAAA;AA4QN;AAxQE;EACE,+CAAA;EACA,sCAAA;EACA,+CAAA;EACA,8CAAA;EACA,mDAAA;AA0QJ;AAxQI;EACE,kEAAA;AA0QN;AAtQE;EAEE,8CAAA;EACA,qCAAA;EACA,8CAAA;EACA,6CAAA;EACA,kDAAA;AAuQJ;AArQI;EACE,iEAAA;AAuQN;AAnQE;EACE,gDAAA;EACA,uCAAA;EACA,+CAAA;EACA,+CAAA;EACA,oDAAA;AAqQJ;AAnQI;EACE,mEAAA;AAqQN;AAjQE;EACE,YAAA;EACA,oBAAA;AAmQJ;AAhQE;EACE,2CAAA;EACA,mCAAA;EACA,6CAAA;AAkQJ;AA3ME;EAnDA,6CAAA;AAiQF;AA1ME;EAlIA,0DAAA;EACA,iDAAA;EACA,0DAAA;EACA,yDAAA;EACA,8DAAA;AA+UF;AA9UE;EACE,6EAAA;AAgVJ;AApNE;EAzHA,uEAAA;EACA,mEAAA;EACA,kEAAA;AAgVF;AA7UE;EACE,wDAAA;EACA,+CAAA;EACA,wDAAA;EACA,uDAAA;EACA,4DAAA;AA+UJ;AA7UI;EACE,2EAAA;AA+UN;AA3UE;EACE,0DAAA;EACA,iDAAA;EACA,0DAAA;EACA,yDAAA;EACA,8DAAA;AA6UJ;AA3UI;EACE,6EAAA;AA6UN;AAzUE;EAEE,yDAAA;EACA,gDAAA;EACA,yDAAA;EACA,wDAAA;EACA,6DAAA;AA0UJ;AAxUI;EACE,4EAAA;AA0UN;AAtUE;EACE,2DAAA;EACA,kDAAA;EACA,0DAAA;EACA,0DAAA;EACA,+DAAA;AAwUJ;AAtUI;EACE,8EAAA;AAwUN;AApUE;EACE,YAAA;EACA,oBAAA;AAsUJ;AAnUE;EACE,2CAAA;EACA,mCAAA;EACA,6CAAA;AAqUJ;AA1QE;EAvDA,6CAAA;AAoUF;AAxQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AA0QJ;AAxQI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA0QN;AAvQI;;EAEE,eAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AAyQN","sourcesContent":["// Миксин для размеров кнопок\n@mixin button-size($size) {\n  $prefix: \"--button-#{$size}\";\n\n  // Базовые свойства для всех кнопок\n  border-radius: var(#{$prefix}-border-radius);\n  min-height: var(#{$prefix}-height);\n\n  .content {\n    border-radius: var(#{$prefix}-border-radius);\n    gap: var(#{$prefix}-gap);\n    padding: var(#{$prefix}-padding-vertical) var(#{$prefix}-padding-horizontal);\n  }\n\n  &.icon-only {\n    .content {\n      padding: var(#{$prefix}-padding-square);\n      aspect-ratio: 1/1;\n      min-width: var(#{$prefix}-height);\n    }\n  }\n}\n\n// Миксин для цветовых стилей кнопок\n@mixin button-style($type) {\n  $prefix: \"--button-#{$type}\";\n\n  // Базовые стили\n  background-color: var(#{$prefix}-default-bg);\n  color: var(#{$prefix}-default-text);\n  border: var(#{$prefix}-default-border, none);\n  opacity: var(#{$prefix}-default-opacity, 1);\n  box-shadow: var(#{$prefix}-default-shadow, none);\n  .content {\n    background-color: var(#{$prefix}-default-state-bg, transparent);\n  }\n\n  font-family: var(#{$prefix}-default-font-family, inherit);\n  font-size: var(#{$prefix}-default-font-size, inherit);\n  font-weight: var(#{$prefix}-default-weight, inherit);\n\n  // Состояния кнопки\n  &:hover:not(:disabled) {\n    background-color: var(#{$prefix}-hover-bg);\n    color: var(#{$prefix}-hover-text);\n    border: var(#{$prefix}-hover-border, none);\n    opacity: var(#{$prefix}-hover-opacity, 1);\n    box-shadow: var(#{$prefix}-hover-shadow, none);\n\n    .content {\n      background-color: var(#{$prefix}-hover-state-bg, transparent);\n    }\n  }\n\n  &:focus-visible {\n    background-color: var(#{$prefix}-focused-bg);\n    color: var(#{$prefix}-focused-text);\n    border: var(#{$prefix}-focused-border, none);\n    opacity: var(#{$prefix}-focused-opacity, 1);\n    box-shadow: var(#{$prefix}-focused-shadow, none);\n\n    .content {\n      background-color: var(#{$prefix}-focused-state-bg, transparent);\n    }\n  }\n\n  &:active:not(:disabled),\n  &[data-active=\"true\"] {\n    background-color: var(#{$prefix}-active-bg);\n    color: var(#{$prefix}-active-text);\n    border: var(#{$prefix}-active-border, none);\n    opacity: var(#{$prefix}-active-opacity, 1);\n    box-shadow: var(#{$prefix}-active-shadow, none);\n\n    .content {\n      background-color: var(#{$prefix}-active-state-bg, transparent);\n    }\n  }\n\n  &:disabled {\n    background-color: var(#{$prefix}-disabled-bg);\n    color: var(#{$prefix}-disabled-text);\n    border: var(#{$prefix}-disabled-border none);\n    opacity: var(#{$prefix}-disabled-opacity, 1);\n    box-shadow: var(#{$prefix}-disabled-shadow, none);\n\n    .content {\n      background-color: var(#{$prefix}-disabled-state-bg, transparent);\n    }\n  }\n\n  &[data-loading=\"true\"] {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n\n  &[data-error=\"true\"] {\n    background-color: var(--M3-sys-light-error);\n    color: var(--M3-sys-light-on-error);\n    border: 1.5px solid var(--M3-sys-light-error);\n  }\n\n  // Анимации\n  transition: background-color 0.2s ease-in-out;\n}\n\n// Базовый класс кнопки\n.btn {\n  display: inline-flex;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n  padding: 0;\n\n  // Размеры\n  &.size-24 {\n    @include button-size(\"24\");\n  }\n\n  &.size-28 {\n    @include button-size(\"28\");\n  }\n\n  &.size-32 {\n    @include button-size(\"32\");\n  }\n\n  &.size-36 {\n    @include button-size(\"36\");\n  }\n\n  &.size-44 {\n    @include button-size(\"44\");\n  }\n\n  &.size-52 {\n    @include button-size(\"52\");\n  }\n\n  // Стили кнопок\n  &.tonal {\n    @include button-style(\"tonal\");\n  }\n\n  &.outlined {\n    @include button-style(\"outlined\");\n  }\n\n  &.filled {\n    @include button-style(\"filled\");\n  }\n\n  &.text {\n    @include button-style(\"text\");\n  }\n\n  &.outlined-danger {\n    @include button-style(\"outlined-danger\");\n  }\n\n  // Контейнер содержимого кнопки\n  .content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    width: 100%;\n\n    span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    svg,\n    i {\n      min-height: 1em;\n      min-width: 1em;\n      flex-shrink: 0;\n      pointer-events: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `SbzwEQvle06ZlSVgWU9w`,
	"size-24": `gIWgNlNf9Iy2aoZ35f5t`,
	"content": `UKnOuM4nRvoF7ovP5IJr`,
	"icon-only": `N6CxTZzjUCVAEFVOinv9`,
	"size-28": `uoQ1r2y19GGD2U4UFiss`,
	"size-32": `cG3uVuAzOLvqU0hYhQ7A`,
	"size-36": `Y8zViTvTRtISvkumYX3b`,
	"size-44": `iYJ2UuVjusqWfXIW4nAD`,
	"size-52": `pjrORQRnyGSU1jo7Ad2V`,
	"tonal": `N1gFS2vuCCAsO9ovSOWV`,
	"outlined": `KRX3MAA5GXAS0Nub_dOr`,
	"filled": `jtCKpfYc2dKTeT2qRwJO`,
	"text": `VC1NiBT59FkoTd4_XRJq`,
	"outlined-danger": `QDvjywShxC4jIa50gFRB`
};
export default ___CSS_LOADER_EXPORT___;
